import type {
  ActivateCreateFormAction,
  CreateCustomKeyIssueDefaultAction,
  CreateCustomKeyIssueFulfilledAction,
  CreateCustomKeyIssueRejectedAction,
  CustomKeyIssueResetTopicSearchIdsForQueryAction,
  CustomKeyIssueTopicSearchDefaultAction,
  CustomKeyIssueTopicSearchFulfilledAction,
  CustomKeyIssueTopicSearchRejectedAction,
} from "domains/customKeyIssue/actionTypes";
import { CustomKeyIssueTypes } from "domains/customKeyIssue/actionTypes";

export const searchTopicForCustomKeyIssue = (
  meta: CustomKeyIssueTopicSearchDefaultAction["meta"],
): CustomKeyIssueTopicSearchDefaultAction => ({
  type: CustomKeyIssueTypes.FETCH_TOPIC_SEARCH,
  meta,
});

export const searchTopicForCustomKeyIssueFulfilled = (
  meta: CustomKeyIssueTopicSearchFulfilledAction["meta"],
  payload: CustomKeyIssueTopicSearchFulfilledAction["payload"],
): CustomKeyIssueTopicSearchFulfilledAction => ({
  type: CustomKeyIssueTypes.FETCH_TOPIC_SEARCH_FULFILLED,
  meta,
  payload,
});

export const searchTopicForCustomKeyIssueRejected = (
  meta: CustomKeyIssueTopicSearchRejectedAction["meta"],
): CustomKeyIssueTopicSearchRejectedAction => ({
  type: CustomKeyIssueTypes.FETCH_TOPIC_SEARCH_REJECTED,
  meta,
});

export const createCustomKeyIssue = (
  meta: CreateCustomKeyIssueDefaultAction["meta"],
): CreateCustomKeyIssueDefaultAction => ({
  type: CustomKeyIssueTypes.CREATE,
  meta,
});

export const createCustomKeyIssueSuccess = (dimensionId?: string): CreateCustomKeyIssueFulfilledAction => ({
  payload: { dimensionId },
  type: CustomKeyIssueTypes.CREATE_FULFILLED,
});

export const createCustomKeyIssueFailure = (): CreateCustomKeyIssueRejectedAction => ({
  type: CustomKeyIssueTypes.CREATE_REJECTED,
});

export const toggleCustomKeyIssueForm = (meta?: ActivateCreateFormAction["meta"]): ActivateCreateFormAction => ({
  type: CustomKeyIssueTypes.ACTIVATE_FORM,
  meta,
});

export const resetTopicSearchIdsForQuery = (): CustomKeyIssueResetTopicSearchIdsForQueryAction => ({
  type: CustomKeyIssueTypes.RESET_TOPIC_SEARCH_IDS_FOR_QUERY,
});
